import React, { useState } from 'react'
import { Navigate, useNavigate, useSearchParams } from 'react-router-dom'

import './login.scss'

import { getSafeRedirectPath } from '../authRedirects'
import { useAuth } from '../contexts/AuthContext'

export const Login = () => {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [showPassword, setShowPassword] = useState(false)
  const auth = useAuth()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const redirectPath = getSafeRedirectPath(searchParams.get('redirect'))

  const getDefaultRedirectPath = (clientName: string) =>
    clientName === 'admin' ? '/admin' : `/${clientName}`
  const canOpenPath = (clientName: string, path: string) => {
    if (clientName === 'admin') return true
    try {
      return decodeURIComponent(path.split(/[/?#]/)[1] ?? '') === clientName
    } catch {
      return false
    }
  }
  const getPostLoginRedirectPath = (clientName: string) =>
    redirectPath && redirectPath !== '/login' && canOpenPath(clientName, redirectPath)
      ? redirectPath
      : getDefaultRedirectPath(clientName)

  if (auth.clientName) {
    return <Navigate to={getPostLoginRedirectPath(auth.clientName)} replace />
  }

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault()

    try {
      const response = await fetch('/api/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ clientName: username, password: password }),
      })

      const data = await response.json()

      if (response.ok) {
        auth.login(data.clientName)
        navigate(getPostLoginRedirectPath(data.clientName), {
          replace: true,
        })
      } else {
        alert(`Login failed: ${typeof data.error === 'string' ? data.error : 'Invalid credentials'}`)
      }
    } catch (_error) {
      alert('An error occurred while logging in.')
    }
  }

  const toggleShowPassword = () => {
    setShowPassword(!showPassword)
  }

  return (
    <div className='login-container'>
      <form onSubmit={handleSubmit} className='login-form'>
        <h2 className='login-title'>Login</h2>
        <input
          id='username'
          type='text'
          value={username}
          onChange={e => setUsername(e.target.value)}
          placeholder='Username'
          className='login-input'
        />
        <div className='login-password-container'>
          <input
            id='password'
            type={showPassword ? 'text' : 'password'}
            value={password}
            onChange={e => setPassword(e.target.value)}
            placeholder='Password'
            className='login-password-input'
          />
          <button
            id='toggle-password'
            type='button'
            onClick={toggleShowPassword}
            className='login-toggle-button'
          >
            {showPassword ? 'Hide' : 'Show'}
          </button>
        </div>
        <button id='login-button' type='submit' className='login-button'>
          Login
        </button>
      </form>
    </div>
  )
}
